import api from '../api';

export async function getSubCategory(slug) {
    const response = await api.get(`/handbook/sub-category/${slug}`);
    return response.data;
}

